import React from 'react';
import { useAppSelector } from '../hooks/redux';

/**
 * Global top progress bar that shows during any RTK Query API call.
 * Thin animated bar at the top of the viewport.
 */
const ProgressBar: React.FC = () => {
  // Check if any RTK Query endpoints are currently loading
  const localApiState = useAppSelector((state) => state.localApi?.queries || {});
  const isLoading = Object.values(localApiState).some(
    (query: any) => query?.status === 'pending'
  );

  if (!isLoading) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[100] h-0.5"
      data-testid="progress-bar"
    >
      <div className="h-full bg-primary-500 animate-progress-bar" />
    </div>
  );
};

export default ProgressBar;
